import { TransactionStatus } from "mobx-store/storeInterfaces/transactionInterface";
import { CardRequestType } from "screens/cardsDeliveryRequestsScreen/types";

export const login = '/auth/admin/login';
export const createAdmin = '/auth/admin/register';
export const getCurrentUser = '/users/me';
export const getAllCountries = '/countries';
export const uploadFileURL = '/fileUpload';
export const forgotPasswordEmail = '/auth/admin/forgotPassword/passwordResetRequest';
export const forgotPasswordValidateToken = '/auth/admin/forgotPassword/tokenValidation';
export const ResetPasswordRequest = '/auth/admin/forgotPassword/passwordReset';
export const refreshTokenRequest = '/auth/refresh';
export const changePasswordRequest = (id: number) => `/auth/admin/${id}/password`;
export const changeMembershipId = '/users/membershipId';
export const suspendUser = (membershipId: string) => `/users/${membershipId}/suspended`;
export const unsuspendUser = (membershipId: string) => `/users/${membershipId}/suspended`;
export const isMainMember = (membershipId: string) => `/users/${membershipId}/is-main-member`;
export const createWalletUser = (userId: number) => `deglawy/users/${userId}/wallet`;
export const getTempPassword = (userId: number) =>
  `auth//tempPassword?userId=${userId}`;

export const user = (userId: number) => `/users/${userId}`;
export const getWheelPrizes = (eventId: number) => `wheel/events/${eventId}/prizes?allPrizes=true`;
export const getWheelPrize = (prizeId: number) => `/wheel/prizes/${prizeId}`;
export const createWheelPrize = (eventId: number) => `/wheel/events/${eventId}/prizes`;
export const getWheelEvents = `/wheel/events`;
export const getWheelEvent = (eventId: number) => `/wheel/events/${eventId}`;
export const checkUserKYCStatus = '/users/sync-limited-user';
export const getWheelEventWinners = (
    eventId: number,pageNumber: number,pageSize: number
) => `wheel/events/${eventId}/winners?pageNumber=${pageNumber}&pageSize=${pageSize}`;
export const retryPointsSubmittion = (eventId: number, winnerId: number) =>
  `wheel/events/${eventId}/winners/${winnerId}/points`;
export const getWheelEventWinnersCsv = (
    eventId: number
) => `wheel/events/${eventId}/winners?type=csv`;
export const getWheelEventsGroups = `wheel/events-groups`;
export const getWheelEventsGroup = (id: number) => `wheel/events-groups/${id}`;
export const accumulation =(userId: string) => `users/${userId}/accumulation`;
export const updatePhoneNumber = (userId: string) => `/users/${userId}/phoneNumber`;
export const memberShipVerification = `auth/registration/membershipVerification`;
export const phoneNumberSelection = `auth/registration/registrationMethodSelection`;
export const smsPhoneCodeVerification = `auth/registration/smsPhoneCodeVerification`;
export const phoneRegistration = `auth/registration/phoneRegistration`;
export const renewalsDetails = (userId: number) => `users/${userId}/renewals`;

export const userDetails = (userId: number) => `users/${userId}`;

export const getUserWifiPackageDetails = (id: number) => `/users/${id}/wifi-subscriptions`;
export const getUsersWifiPackagesSubscription = (
  pageNumber: number, pageSize: number, filterValue: string,
) => `/users/wifi-subscriptions?pageNumber=${pageNumber}&pageSize=${pageSize}&filterValue=${filterValue}`;

export const deliveryRegionsUrl = 'shop/delivery-regions';
export const deliveryRegionById = (id: number) => `${deliveryRegionsUrl}/${id}`;
export const cardsDelivery = 'cards-delivery';

export const cardsDeliveryExport = (
  status: any, paid: boolean, q?: string, from?: string, to?: string, branch?: string, payment?: 'all' | 'F' | 'P', paymentStatuses?: TransactionStatus [],
  requestType?: CardRequestType
) => `/${cardsDelivery}/export?status=${status}${
  q ? `&q=${q}` : ''
}${
  from ? `&from=${from}` : ''
}${
  to ? `&to=${to}` : ''
}${
  branch ? `&branch=${branch}` : ''
}${
  payment ? `&payment=${payment}` : ''
}${
  paid ? `&paid=${paid}` : ''
}${
  paymentStatuses ? `&paymentStatuses=${paymentStatuses}` : ''
}${
  requestType ? `&requestType=${requestType}` : ''
}`;

export const cardsDeliveryRequestsList = (
  pageNumber: number, pageSize: number, status: any, paid:boolean, q?: string,
  from?: string, to?: string, branch?: string, payment?: 'all' | 'F' | 'P', paymentStatuses?: TransactionStatus [],
  requestType?: CardRequestType
) => `/${cardsDelivery}?pageNumber=${pageNumber}&pageSize=${pageSize}&status=${status}${
  q ? `&q=${q}` : ''
}${
  from ? `&from=${from}` : ''
}${
  to ? `&to=${to}` : ''
}${
  branch ? `&branch=${branch}` : ''
}${
  payment ? `&payment=${payment}` : ''
}${
  paid ? `&paid=${paid}` : ''
}${
  paymentStatuses ? `&paymentStatuses=${paymentStatuses}` : ''
}${
  requestType ? `&requestType=${requestType}` : ''
}`;

export const pickupBranchesListUrl = `/${cardsDelivery}/pickup-branches`;

export const AddNoAccessList = 'no-access-wheel/create';
export const DeleteNoAccessList = 'no-access-wheel/delete';
export const NoAccessList = (pageNumber:number,pageSize:number,search?:string)=>`no-access-wheel?pageNumber=${pageNumber}&pageSize=${pageSize}&search=${search}`;
